import { UserContext } from 'providers/user/UserProvider';
import { useContext } from 'react';

const useCurrentUser = () => useContext(UserContext);

export { useCurrentUser };
